<template>
  <vx-card no-shadow>

    <h2 class="mb-6">User - Planday integration</h2>

    <div class="vx-row mb-2">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Planday SSN:</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input v-if="user" class="w-full" v-model="user.plandaySsn" placeholder="Planday SSN" />
      </div>
    </div>

    <div class="vx-row  mb-6">
      <div class="vx-col sm:w-1/5 w-full">
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-button @click="copySsnFromUser" color="success" class="ml-auto mt-2">Copy from User</vs-button>
      </div>
    </div>

    <vs-divider />

    <div class="vx-col lg:w-1/1 w-full">
      <h5 class="mb-6">Test Integration</h5>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-2/5 w-full">
        <vs-button @click="showPlandayUserInfo" color="warning" class="ml-auto mt-2">Show Planday User Info</vs-button>
      </div>
    </div>

    <div v-if="plandayData">
      <div class="vx-col lg:w-1/1 w-full">
        <h6 class="mb-6">Found User in {{ plandayData.portalUsers.length }} Portals:</h6>
      </div>

      <div v-for="plandayUser in plandayData.portalUsers" :key="plandayUser.id" class="vx-row mb-6">
        <div class="vx-col sm:w-2/5 w-full">
          <vx-card>
            <div class="my-6">
              <h5 class="mb-2">{{ plandayUser.firstName }} {{ plandayUser.lastName }}</h5>
              <p><span class="text-grey">E-mail:</span> {{ plandayUser.email }}</p>
              <p><span class="text-grey">SSN:</span> {{ plandayUser.ssn }}</p>
              <p><span class="text-grey">Matched on:</span> {{ plandayUser.matchSource }}</p>
            </div>
            <vs-divider></vs-divider>
            <div class="my-6">
              <h5 class="mb-2">{{ plandayUser.portal.name }}</h5>

              <div class="mb-2">
                <p class="text-grey">Positions:</p>
                <vs-chip v-for="position in plandayUser.positions" :key="position" color="success">
                  {{ position }}
                </vs-chip>
                <vs-chip v-if="plandayUser.positions.length === 0">
                  No positions
                </vs-chip>
              </div>

              <div style="clear:both;margin-top: 35px;" v-if="plandayUser.unhandledEmployeeGroups.length > 0">
                <p class="text-grey">Other Employee Groups:</p>
                <vs-chip v-for="group in plandayUser.unhandledEmployeeGroups" :key="group" color="warning">
                  {{ group }}
                </vs-chip>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </div>

    <vs-divider />

    <div class="flex flex-wrap items-center justify-end">
      <vs-button @click="saveInfo" id="save-button" class="ml-auto mt-2">Save Changes</vs-button>
    </div>
  </vx-card>
</template>

<script>

export default {
  data () {
    return {
      user: null,
      plandayData: null
    }
  },
  methods: {
    copySsnFromUser: function () {
      this.user.plandaySsn = this.user.ssn;
    },

    showPlandayUserInfo: function () {
      this.$vs.loading()

      this.$http.get(process.env.VUE_APP_API +'/user/' + this.user.userId + '/planday')
          .then((resp) => {
            console.log(resp.data);

            this.plandayData = resp.data;
          })
          .catch(err => {
            this.$vs.notify({
              color:'danger',
              title:'Error',
              text:'Could not fetch user in Planday:' + err
            });
          })
          .finally(() => {
            this.$vs.loading.close()
          })
    },

    getUser: function (userId) {
      this.$vs.loading()

      this.$http.get(process.env.VUE_APP_API +'/users/' + userId)
          .then(resp => {
            this.user = resp.data

            console.log(this.user);
          })
          .catch(err => {
            this.$vs.notify({
              color:'danger',
              title:'Error',
              text:'Could not fetch user:' + err
            });
          })
          .finally(() => {
            this.$vs.loading.close()
          })
    },

    saveInfo: function () {
      this.$vs.loading({
        background:'primary',
        color:'#fff',
        container: "#save-button",
        scale: 0.45
      });

      const payload = {
        plandaySsn: this.user.plandaySsn
      };

      this.$http.put(process.env.VUE_APP_API +'/user/' + this.user.userId + '/info/planday', payload)
          .then(resp => {
            console.log(resp.data);

            this.$vs.notify({
              color:'success',
              title:'Success',
              text:'Info updated'
            })
          })
          .catch(err => {
            console.log(err)

            this.$vs.notify({
              color:'danger',
              title:'Error',
              text:'Could not update info'
            });
          })
          .finally(() => {
            this.$vs.loading.close("#save-button > .con-vs-loading")
          })
    }
  },
  created() {
    this.getUser(this.$route.params.userId);
  }
}
</script>

<style lang="scss" scoped>
.horizontal-row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
</style>